import { useDispatch, useSelector } from 'react-redux';
import { useDidMount, useDidUpdate } from 'rooks';
import { login } from '../redux/actions';
import { parseURLParams } from '../utils/helpers';

const AuthProvider = ({ children }) => {
	const token = useSelector((state) => state.user?.token);
	const dispatch = useDispatch();
	const params = parseURLParams(window.location.href);
	const code = params?.code?.[0];

	const authorizeUser = () => {
		dispatch(login(token, code));
	};

	useDidMount(authorizeUser);
	useDidUpdate(authorizeUser, [token, code]);
	return children;
};

export default AuthProvider;
